import devadigaidol from '../assets/cards/devadigaidol.jpg';
import devadigaworld from '../assets/images/devadiga.world.jpg';
import decorbysachinsherigar from '../assets/cards/decorbysachinsherigar.jpg';
import sri_durga_fhoto_frems from '../assets/cards/sri_durga_fhoto_frems.jpg';
import sunrefrigeration from '../assets/cards/sunrefrigeration.jpg';
import MaheshEngineeringWorksDevadiga from '../assets/cards/MaheshEngineeringWorksDevadiga.jpg';
import laxmi_wood_designer from '../assets/cards/laxmi_wood_designer.jpg';
import DevadigaUnited from '../assets/cards/DevadigaUnited.jpg';
import DNSBlr from '../assets/cards/DNSBlr.jpg';
import amrutheshwara_chende_makers from '../assets/cards/amrutheshwara_chende_makers.jpg';
import makarandaemporium from '../assets/cards/makarandaemporium.jpg';
import kaveritraders from '../assets/cards/kaveritraders.png';
import lensbox from '../assets/cards/lensbox.jpg';
import VikasFood from '../assets/cards/VikasFood.jpg';
import ShreeSaubhagyaChandeBalaga from '../assets/cards/ShreeSaubhagyaChandeBalaga.jpg';
import NarayansSandwichHouse from '../assets/cards/NarayansSandwichHouse.jpg';
import ifruit from '../assets/cards/ifruit.jpg';

const CardsData = [

  {
    id: 1,
    name: 'Devadiga Idol',
    description: '',
    logo: devadigaidol,
    category: 'Community Page',
    address: '',
    email: '',
    phone: '',
    links: [
      {
        href: 'https://www.instagram.com/devadigaidol/',
        text: 'Instagram'
      },
      {
        href: 'https://www.facebook.com/devadigaidol/',
        text: 'Fb Page'
      },
      {
        href: 'https://www.facebook.com/groups/devadigaidol',
        text: 'Fb Group'
      }
    ]
  },
  {
    id: 2,
    name: 'Devadiga World',
    description: '',
    logo: devadigaworld, // https://via.placeholder.com/150
    category: 'Community Page',
    address: '',
    email: 'devadiga.world@outlook.com',
    phone: '',
    links: [
      {
        href: 'https://www.instagram.com/devadiga.world/',
        text: 'Instagram'
      },
      {
        href: 'https://devadiga.vercel.app/',
        text: 'Website'
      }
    ]
  },
  {
    id: 3,
    name: 'Devadiga United',
    description: '',
    logo: DevadigaUnited,
    category: 'Community Page',
    address: '',
    email: 'devadigaunitedgroup@gmail.com',
    phone: '',
    links: [
      {
        href: 'https://www.instagram.com/devadigaunited/',
        text: 'Instagram'
      },
      {
        href: 'https://www.facebook.com/DevadigaUnited',
        text: 'Fb Page'
      },
      {
        href: 'https://www.facebook.com/groups/devadigaunited/',
        text: 'Fb Group'
      }
    ]
  },
  {
    id: 4,
    name: 'DEVADIGA NOVODAYA SANGHA (R) BANGLORE',
    description: 'One team Many Dreams... Join together for future development of Devadiga Community',
    logo: DNSBlr,
    category: 'Community Page',
    address: 'Bangalore, India, Karnataka',
    email: 'devadiganavodayasangha@gmail.com',
    phone: '093807 68433',
    links: [
      {
        href: 'https://www.instagram.com/devadiga_navodaya_sangha_blr/?hl=en',
        text: 'Instagram'
      },
      {
        href: 'https://www.facebook.com/DNSBlr/',
        text: 'Fb Page'
      },
      {
        href: 'https://www.youtube.com/@dnsblr',
        text: 'Youtube'
      }
    ]
  },
  {
    id: 5,
    name: 'Decor By Sachin Sherigar',
    description: '',
    logo: decorbysachinsherigar,
    category: 'Wedding planner',
    address: 'Chandrika Extension, 3-33-2922, Kadri Kambla Rd, Post, Bejai, Mangaluru, Karnataka 575004',
    email: 'decor@sachinsherigar.com',
    phone: '099025 99000',
    links: [
      {
        href: 'https://www.instagram.com/decorbysachinsherigar',
        text: 'Instagram'
      },
      {
        href: 'https://www.facebook.com/decorbysachinsherigar/',
        text: 'Facebook'
      }
    ]
  },
  {
    id: 6,
    name: 'Sri Durga Photo Frames',
    description: '',
    logo: sri_durga_fhoto_frems,
    category: 'Picture Frame',
    address: 'Shri Devi Complex, Santhekatte, Belthangady, Karnataka 574 214',
    email: '',
    phone: '9731143053, 9901652987',
    links: [
      {
        href: 'https://www.instagram.com/sri_durga_fhoto_frems',
        text: 'Instagram'
      }
    ]
  },
  {
    id: 7,
    name: 'Sun Refrigeration',
    description: 'Nischal S Devadiga',
    logo: sunrefrigeration,
    category: 'Air Conditioning',
    address: 'Padmaraja Nagara, Alangar, Moodabidiri 574227',
    email: '',
    phone: '6361616238, 6363708803',
    links: []
  },
  {
    id: 8,
    name: 'Mahesh Engineering Works Devadiga',
    description: 'ಮಹೇಶ್ ಇಂಜಿನಿಯರಿಂಗ್ ವರ್ಕ್ಸ್ ದೇವಾಡಿಗ',
    logo: MaheshEngineeringWorksDevadiga,
    category: 'Fabrication Engineer',
    address: '9P2X+JR9, Unnamed Road, Nittur, Udupi, Karnataka 576103',
    email: '',
    phone: '09743285688',
    links: []
  },
  {
    id: 9,
    name: 'LAXMI WOOD DESIGNER',
    description: 'Interior work, Wood work, CNC design, Furniture',
    logo: laxmi_wood_designer,
    category: 'Home Improvement',
    address: 'Near Bhahubali Pravachana Mandira Danshale Karkala',
    email: '',
    phone: '+91 9844608017',
    links: [
      {
        href: 'https://www.instagram.com/laxmi_wood_designer/?hl=en',
        text: 'Instagram'
      }
    ]
  },
  {
    id: 10,
    name: 'Amrutheshwara Chende Makers',
    description: 'ನಮ್ಮಲ್ಲಿ ಎಲ್ಲಾ ತರದ ಚರ್ಮ ವಾದ್ಯಗಳ ರಿಪೇರಿ ಹಾಗು ತಯಾರಿಸಿ ಕೊಡಲಾಗುವುದು',
    logo: amrutheshwara_chende_makers,
    category: 'Musical Instruments',
    address: '',
    email: '',
    phone: '8618124795, 8150993354',
    links: [
      {
        href: 'https://www.instagram.com/_amrutheshwara_chende_makers/',
        text: 'Instagram'
      }
    ]
  },
  {
    id: 11,
    name: 'Makarandha Emporium',
    description: "We provide All Pooja Samagri's, Mangalore Store eatery Products, Pingaara & Malligey, All of these are also delivered at your door step!! You can place your order through whatsapp at +91 9930627622",
    logo: makarandaemporium,
    category: 'Pooja Materials',
    address: 'Opp Uma Hospital, 90 feet Road, Sakinaka Mumbai 400072',
    email: '',
    phone: '+91 9930627622',
    links: [
      {
        href: 'https://wa.me/c/919930627622',
        text: 'Whatsapp'
      }
    ]
  },
  {
    id: 12,
    name: 'Kaveri Traders',
    description: "Khobra, Cashew, Badam, Black Pepper, Kishmish, Jeera",
    logo: kaveritraders,
    category: 'Dry Fruits',
    address: 'Dombivli - West',
    email: '',
    phone: '+91 9082755125, +91 9702849116',
    links: [
      {
        href: 'https://wa.me/c/918689980845',
        text: 'Whatsapp'
      }
    ]
  },
  {
    id: 13,
    name: 'Lensbox Photography Mangalore',
    description: "Wedding Photography ||Model photography ||Pre-post Wedding ||Cinematic videography |Baby shoot 📸",
    logo: lensbox,
    category: 'Photography',
    address: 'Mangalore',
    email: '',
    phone: '7353922214',
    links: [
      {
        href: 'https://www.instagram.com/lensbox_photography_mangalore/?hl=en',
        text: 'Instagram'
      }
    ]
  },
  {
    id: 14,
    name: 'Vikas Lunch Home',
    description: "Veg and Non Veg",
    logo: VikasFood,
    category: 'Hotel',
    address: 'Attur Church Road, Kabettu, Karkala',
    email: '',
    phone: '7892138077',
    links: []
  },
  {
    id: 15,
    name: 'Shree Saubhagya Chande Balaga',
    description: "Aneesh Devadiga",
    logo: ShreeSaubhagyaChandeBalaga,
    category: 'Chande',
    address: 'Alankaru, Kadaba',
    email: '',
    phone: '7795115778',
    links: []
  },
  {
    id: 16,
    name: 'Narayan\'s Sandwich House',
    description: "By Sampat Devadiga",
    logo: NarayansSandwichHouse,
    category: 'Fast food restaurant',
    address: 'Mittal Estate,Building No 1,Shop No 2,Andheri [E], Mumbai, India, Maharashtra',
    email: 'narayansandwichhouse@gmail.com',
    phone: '098675 77731',
    links: [
      {
        href: 'https://www.facebook.com/profile.php?id=100064126952987',
        text: 'Facebook'
      }
    ]
  },
  {
    id: 17,
    name: 'iFruit Live Ice Cream',
    description: "By Dhanraj Devadiga",
    logo: ifruit,
    category: 'Ice cream shop',
    address: 'Old Post Office Rd, Thenkpete, Maruthi Veethika, Udupi, Karnataka 576101',
    email: '',
    phone: '081970 31857',
    links: [ ]
  }
  // Add more dummy data as needed
];

export default CardsData;
